import ApiService from '../api.service'
import { Abono } from './abono'
import { AfastamentoV2 } from './afastamentos'
import { Empresa } from './empresas'
import { FaltaCadastrada } from './faltas-cadastradas'
import { CompensacaoFeriado } from './feriados'
import { Funcionario } from './funcionario'
import { Registro } from './registros'
import { Usuario } from './usuarios'

export type Alteracao = {
    id: number
    diff: unknown
    usuarioId: number
    createdAt: Date
    motivo?: string
    modulo: string
    Usuario: Partial<Usuario>

    empresaId?: number
    Empresa?: Empresa
    abonoId?: number
    Abono?: Abono
    afastamentoId?: number
    Afastamento?: AfastamentoV2
    compensacaoFeriadoId?: number
    CompensacaoFeriado?: CompensacaoFeriado
    registroId?: number
    Registro?: Registro
    funcionarioId?: number
    Funcionario?: Funcionario
    faltaId?: number
    FaltaCadastrada?: FaltaCadastrada
}

interface QueryParams {
    dataInicial: string
    dataFinal: string
}

export const alteracoes_api = new ApiService<never, Alteracao, QueryParams>(
    'alteracoes',
)
